const StrategyType = {
  P2P: 'p2p',
  SFU: 'sfu',
}
export {StrategyType}
